import { render, staticRenderFns } from "./ErrorOrder.vue?vue&type=template&id=207f0787"
import script from "./ErrorOrder.vue?vue&type=script&lang=js"
export * from "./ErrorOrder.vue?vue&type=script&lang=js"
import style0 from "./ErrorOrder.vue?vue&type=style&index=0&id=207f0787&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports